/** Per-locale strings for the home hero overlay (above video / background). */
export type HeroHomeLocaleBlock = {
  title: string;
  desc: string;
  cta: string;
};

export type HeroHomeTextConfig = {
  ar: HeroHomeLocaleBlock;
  en: HeroHomeLocaleBlock;
};

export const EMPTY_HERO_HOME_BLOCK: HeroHomeLocaleBlock = { title: '', desc: '', cta: '' };

export function normalizeHeroHomeTextConfig(raw: unknown): HeroHomeTextConfig | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const pick = (lang: 'ar' | 'en'): HeroHomeLocaleBlock => {
    const b = o[lang];
    if (!b || typeof b !== 'object') return { ...EMPTY_HERO_HOME_BLOCK };
    const x = b as Record<string, unknown>;
    return {
      title: typeof x.title === 'string' ? x.title : '',
      desc: typeof x.desc === 'string' ? x.desc : '',
      cta: typeof x.cta === 'string' ? x.cta : ''
    };
  };
  return { ar: pick('ar'), en: pick('en') };
}
